import React from 'react';
import { IconButton, Popover, IconButtonProps } from '@radix-ui/themes';
import classNames from 'classnames';
import styles from '../styles/SmartPlayer.module.css';

type PopoverContentProps = React.ComponentProps<typeof Popover.Content>;

interface PlayerIconButtonProps extends IconButtonProps {
    active?: boolean;
}

export const PlayerIconButton = React.forwardRef<
    HTMLButtonElement,
    PlayerIconButtonProps
>(({ className, active, ...props }, ref) => (
    <IconButton
        ref={ref}
        size='2'
        variant='ghost'
        color='gray'
        highContrast
        className={classNames(styles.iconButton, className)}
        data-active={active}
        {...props}
    />
));
PlayerIconButton.displayName = 'PlayerIconButton';

export const SolidPopoverContent: React.FC<PopoverContentProps> = ({
    className,
    children,
    ...props
}) => (
    <Popover.Content
        side='top'
        align='end'
        sideOffset={12}
        className={classNames(styles.solidPanel, className)}
        {...props}
    >
        {children}
    </Popover.Content>
);
